
export interface AnimatedSVGProps {
  animate: boolean
}

const QuerySVG = ({ animate }: AnimatedSVGProps) => {
  return (
    <svg
      width="251"
      height="336"
      viewBox="0 0 251 336"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${animate ? 'slide-up glow-animation' : ''}`}
    >
      <g id="glowGroup" filter={`url(#${animate ? 'glow' : ''})`}>
        <path d="M28 75H88" stroke="white" strokeWidth="12" strokeLinecap="round" />
        <path d="M168 75H228" stroke="white" strokeWidth="12" strokeLinecap="round" />
        <path d="M88 115H138" stroke="white" strokeWidth="12" strokeLinecap="round" />
        <path d="M68 155H128" stroke="white" strokeWidth="12" strokeLinecap="round" />
        <path d="M138 245H228" stroke="white" strokeWidth="12" strokeLinecap="round" />
        <path d="M128 185H188" stroke="white" strokeWidth="12" strokeLinecap="round" />
        <path d="M28 225H98" stroke="white" strokeWidth="12" strokeLinecap="round" />
      </g>

      <path
        d="M76.4116 17.8977H81.1161L83.4812 20.9403L85.8079 23.6506L90.1928 29.1477H85.0281L82.011 25.4403L80.4641 23.2415L76.4116 17.8977ZM90.5891 13.9091C90.5891 16.7642 90.0479 19.1932 88.9656 21.196C87.8917 23.1989 86.4258 24.7287 84.5678 25.7855C82.7184 26.8338 80.6389 27.358 78.3292 27.358C76.0025 27.358 73.9144 26.8295 72.065 25.7727C70.2156 24.7159 68.7539 23.1861 67.68 21.1832C66.6062 19.1804 66.0692 16.7557 66.0692 13.9091C66.0692 11.054 66.6062 8.625 67.68 6.62216C68.7539 4.61932 70.2156 3.09375 72.065 2.04545C73.9144 0.988636 76.0025 0.460226 78.3292 0.460226C80.6389 0.460226 82.7184 0.988636 84.5678 2.04545C86.4258 3.09375 87.8917 4.61932 88.9656 6.62216C90.0479 8.625 90.5891 11.054 90.5891 13.9091ZM84.9769 13.9091C84.9769 12.0597 84.6999 10.5 84.146 9.23011C83.6005 7.96023 82.8292 6.99716 81.832 6.34091C80.8349 5.68466 79.6673 5.35653 78.3292 5.35653C76.9911 5.35653 75.8235 5.68466 74.8264 6.34091C73.8292 6.99716 73.0536 7.96023 72.4996 9.23011C71.9542 10.5 71.6815 12.0597 71.6815 13.9091C71.6815 15.7585 71.9542 17.3182 72.4996 18.5881C73.0536 19.858 73.8292 20.821 74.8264 21.4773C75.8235 22.1335 76.9911 22.4616 78.3292 22.4616C79.6673 22.4616 80.8349 22.1335 81.832 21.4773C82.8292 20.821 83.6005 19.858 84.146 18.5881C84.6999 17.3182 84.9769 15.7585 84.9769 13.9091ZM107.18 18.6392V7.36364H112.626V27H107.397V23.4332H107.192C106.749 24.5838 106.012 25.5085 104.981 26.2074C103.958 26.9062 102.71 27.2557 101.235 27.2557C99.9226 27.2557 98.7678 26.9574 97.7706 26.3608C96.7734 25.7642 95.9936 24.9162 95.4311 23.8168C94.8771 22.7173 94.5959 21.4006 94.5874 19.8665V7.36364H100.033V18.8949C100.042 20.054 100.353 20.9702 100.967 21.6435C101.58 22.3168 102.403 22.6534 103.434 22.6534C104.09 22.6534 104.704 22.5043 105.275 22.206C105.846 21.8991 106.306 21.4474 106.656 20.8509C107.013 20.2543 107.188 19.517 107.18 18.6392ZM125.931 27.3835C123.911 27.3835 122.172 26.9744 120.715 26.1562C119.266 25.3295 118.15 24.1619 117.365 22.6534C116.581 21.1364 116.189 19.3423 116.189 17.2713C116.189 15.2514 116.581 13.4787 117.365 11.9531C118.15 10.4276 119.253 9.23864 120.676 8.38636C122.108 7.53409 123.787 7.10795 125.713 7.10795C127.009 7.10795 128.215 7.31676 129.331 7.73438C130.456 8.14347 131.436 8.76136 132.272 9.58807C133.115 10.4148 133.772 11.4545 134.24 12.7074C134.709 13.9517 134.944 15.4091 134.944 17.0795V18.5753H118.363V15.2003H129.817C129.817 14.4162 129.647 13.7216 129.306 13.1165C128.965 12.5114 128.492 12.0384 127.887 11.6974C127.29 11.348 126.596 11.1733 125.803 11.1733C124.976 11.1733 124.243 11.3651 123.604 11.7486C122.973 12.1236 122.479 12.6307 122.121 13.2699C121.763 13.9006 121.58 14.6037 121.571 15.3793V18.5881C121.571 19.5597 121.75 20.3991 122.108 21.1065C122.475 21.8139 122.99 22.3594 123.655 22.7429C124.32 23.1264 125.108 23.3182 126.02 23.3182C126.625 23.3182 127.179 23.233 127.682 23.0625C128.185 22.892 128.615 22.6364 128.973 22.2955C129.331 21.9545 129.604 21.5369 129.792 21.0426L134.828 21.375C134.573 22.5852 134.049 23.642 133.256 24.5455C132.472 25.4403 131.458 26.1392 130.213 26.642C128.978 27.1364 127.55 27.3835 125.931 27.3835ZM138.498 27V7.36364H143.777V10.7898H143.982C144.34 9.57102 144.941 8.65057 145.784 8.02841C146.628 7.39773 147.6 7.08239 148.699 7.08239C148.972 7.08239 149.266 7.09943 149.581 7.13352C149.897 7.16761 150.174 7.21449 150.412 7.27415V12.1065C150.157 12.0298 149.803 11.9616 149.351 11.902C148.9 11.8423 148.486 11.8125 148.111 11.8125C147.31 11.8125 146.594 11.9872 145.963 12.3366C145.341 12.6776 144.847 13.1548 144.48 13.7685C144.123 14.3821 143.944 15.0895 143.944 15.8906V27H138.498ZM157.188 34.3636C156.498 34.3636 155.85 34.3082 155.245 34.1974C154.648 34.0952 154.154 33.9631 153.762 33.8011L154.989 29.7358C155.628 29.9318 156.203 30.0384 156.715 30.0554C157.235 30.0724 157.682 29.9531 158.057 29.6974C158.441 29.4418 158.752 29.0071 158.99 28.3935L159.31 27.5625L152.266 7.36364H157.993L162.059 21.7841H162.263L166.367 7.36364H172.132L164.5 29.1222C164.134 30.179 163.635 31.0994 163.005 31.8835C162.382 32.6761 161.594 33.2855 160.64 33.7116C159.685 34.1463 158.534 34.3636 157.188 34.3636Z"
        fill="white"
      />
      <path d="M28 95H108" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M158 115H228" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M28 135H178" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M108 75H148" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M28 75H88" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M128 95H188" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M198 135H228" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M28 155H48" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M28 185H108" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M118 225H178" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M208 185H228" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M128 185H188" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M198 225H228" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M28 245H118" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M138 245H228" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M28 205H78" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M98 205H138" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M158 205H228" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M28 115H68" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path
        d="M208 95L227.653 95.1566"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M168 75L227.998 75.4781"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path d="M88 115H138" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M68 155H128" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M28 225H98" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path
        d="M250.422 47.2075V335.94H51.2505L0.568359 291.86L0.576953 47.2075H250.422Z"
        fill="#F5F5F5"
        fillOpacity="0.1"
      />
      <path
        d="M250.422 47.2075V335.94H51.2505L0.568359 291.86V47.2075H250.422Z"
        fill="#F5F5F5"
        fillOpacity="0.1"
      />
      <path
        d="M250.422 47.2075V335.94H51.2505L0.568359 291.86V47.2075H250.422Z"
        fill="#F5F5F5"
        fillOpacity="0.1"
      />
      <path
        d="M55.7016 288.76V335.948H51.5605C51.1567 335.948 55.169 339.323 0.620605 291.86V288.76H55.7016Z"
        fill="url(#paint0_linear_24_2)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_24_2"
          x1="0.577647"
          y1="312.382"
          x2="55.7016"
          y2="312.382"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9AFC4" />
          <stop offset="1" stopColor="#D4D8E5" />
        </linearGradient>

        <filter id="glow" height="300%" width="300%" x="-75%" y="-75%">
          {/* Use a gaussian blur to create the soft blurriness of the glow */}
          <feGaussianBlur in="thicken" stdDeviation="5" result="blurred" />

          {/* Change the color */}
          <feFlood floodColor="rgb(0,186,255)" result="glowColor" />

          {/* Color in the glows */}
          <feComposite in="glowColor" in2="blurred" operator="in" result="softGlow_colored" />

          {/*	Layer the effects together */}
          <feMerge>
            <feMergeNode in="softGlow_colored" />
          </feMerge>
        </filter>
      </defs>
    </svg>
  );
}

export default QuerySVG;
